const AppLogo = () => (
	<svg width={64} height={64} fill="none">
		<rect width={64} height={64} fill="#0D194F" rx={14} />
		<path
			fill="#39F589"
			fillRule="evenodd"
			d="M51.442 18.159h-9.427a.823.823 0 0 0-.77.555l-4.31 11.928-6.3.214 4.502-12.124c.101-.277-.097-.573-.384-.573h-9.92a.822.822 0 0 0-.766.543l-4.656 12.52c-2.667.084-4.962.15-6.783.195a.822.822 0 0 0-.746.545l-1.484 4.001c-.105.283.1.586.394.576 1.737-.059 4.02-.146 6.739-.257l-3.992 10.736c-.111.292.108.602.41.578 3.415-.273 6.83-.533 10.247-.78a.828.828 0 0 0 .713-.543l3.886-10.465 6.371-.272-3.676 10.172c-.104.289.11.593.408.573 3.071-.206 6.276-.41 9.606-.613a.828.828 0 0 0 .723-.548l9.6-26.394c.097-.276-.1-.567-.385-.567"
			clipRule="evenodd"
		/>
	</svg>
);

export default AppLogo;
